<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="content-grid">
            <div style="display: flex; justify-content: space-between;">
                <h2 class="content-block">Banks</h2>
            </div>
            <dx-data-grid class="dx-card wide-card" [dataSource]="bankDataSource" [showBorders]="false"
                [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true"
                keyExpr="Id">

                <dxo-paging [pageSize]="15"></dxo-paging>
                <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>

                <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
                    <dxo-popup title="Bank" [showTitle]="true" [width]="700" [height]="525">
                    </dxo-popup>
                    <dxo-paging [pageSize]="10"></dxo-paging>
                    <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-form>
                        <!-- <dxi-item dataField="Name" [colSpan]="2">
                            <dxi-validation-rule type="required" message="Name is required">
                            </dxi-validation-rule>
                        </dxi-item> -->
                        <dxi-item dataField="Identifier" [colSpan]="2"></dxi-item>
                        <dxi-item dataField="Description" editorType="dxTextArea" [colSpan]="2"
                            [editorOptions]="{ height: 100 }">
                        </dxi-item>
                        <dxi-item dataField="BranchCodeUniversal" [colSpan]="2"></dxi-item>
                    </dxo-form>
                </dxo-editing>
                <!-- <dxi-column dataField="Name" caption="Name">
                </dxi-column> -->

                <dxi-column dataField="Identifier" caption="Identifier">
                </dxi-column>

                <dxi-column dataField="Description" caption="Description">
                </dxi-column>

                <dxi-column dataField="BranchCodeUniversal" caption="BranchCodeUniversal">
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>
</div>